var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandymanRepairMaintenanceTechnician(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3.75C5.75 2.23125 6.98125 1.25 8.5 1.25H9.5C11.0187 1.25 12.25 2.23125 12.25 3.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5L12.2113 5.57688C12.156 5.68876 12.0605 5.77561 11.9439 5.82001C11.8273 5.86441 11.6982 5.86306 11.5825 5.81625C11.0331 5.59437 10.0163 5.25 9 5.25C8.11471 5.25393 7.23939 5.4372 6.42688 5.78875C6.30978 5.84051 6.17728 5.84538 6.0567 5.80236C5.93612 5.75934 5.83663 5.67169 5.77875 5.5575L5.5 5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4C7 4 8.625 3.75 9 3.75C9.375 3.75 11 4 11 4",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2734 9.71125C10.6589 9.52652 10.998 9.25769 11.2659 8.92454C11.5337 8.59139 11.7234 8.20241 11.8209 7.78625C11.9516 7.24313 12.0016 7 12.0016 7",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7C6 7 6.04938 7.2425 6.17875 7.78625C6.27909 8.21299 6.47618 8.61094 6.7548 8.94938C7.03342 9.28782 7.38611 9.55769 7.78562 9.73812",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3325 10.6327C10.895 10.3827 11.0043 9.20703 11.0043 9.20703",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98977 9.20215C6.98977 9.20215 7.22914 10.344 6.65039 10.6396",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 11.2503L11.332 10.6328",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 11.2504L6.65062 10.6416",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3316 10.6328C10.8123 11.5297 10.1104 12.0003 8.99977 12.0003C7.88914 12.0003 7.16852 11.5391 6.65039 10.6416",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 15.25C5.2197 15.6893 4.93185 16.0695 4.55122 16.3382C4.17058 16.6069 3.71592 16.7508 3.25 16.75C2.36625 16.75 1.5 16.25 1.25 15.5H3L3.5 15V14L3 13.5H1.25C1.625 12.7763 2.37937 12.25 3.25 12.25C3.71592 12.2492 4.17058 12.3931 4.55122 12.6618C4.93185 12.9305 5.2197 13.3107 5.375 13.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.627 13.75C12.7821 13.3112 13.0694 12.9314 13.4495 12.6627C13.8295 12.3941 14.2834 12.2499 14.7488 12.25C15.6195 12.25 16.3738 12.7763 16.7488 13.5H15.2488L14.7488 14V15L15.2488 15.5H16.7488C16.4988 16.25 15.6195 16.75 14.7488 16.75C14.2834 16.7501 13.8295 16.6059 13.4495 16.3373C13.0694 16.0686 12.7821 15.6888 12.627 15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26367 13.5H12.7349",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7349 15.5H5.26367",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandymanRepairMaintenanceTechnician);
export default __webpack_public_path__ + "static/media/handyman-repair-maintenance-technician.9acbd58e.svg";
export { ForwardRef as ReactComponent };